import { render, staticRenderFns } from "./TagsListHorizontal.vue?vue&type=template&id=652150b9&scoped=true&"
import script from "./TagsListHorizontal.vue?vue&type=script&lang=js&"
export * from "./TagsListHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./TagsListHorizontal.vue?vue&type=style&index=0&id=652150b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652150b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
